import React from "react";
import { FaMapMarkerAlt, FaRulerCombined } from "react-icons/fa";

const landListings = [
  {
    id: 1,
    title: "Fertile Farmland",
    location: "South Karnataka",
    area: "25 Acres",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    price: "₹45,000/acre/year"
  },
  {
    id: 2,
    title: "South Farm Land",
    location: "Tamil Nadu",
    area: "15 Acres",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b",
    price: "₹38,000/acre/year"
  },
  {
    id: 3,
    title: "West Range",
    location: "Maharashtra",
    area: "30 Acres",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    price: "₹42,000/acre/year"
  },
  {
    id: 4,
    title: "Green Valley",
    location: "Punjab",
    area: "20 Acres",
    image: "https://images.unsplash.com/photo-1589328956162-4e2f54b36881",
    price: "₹50,000/acre/year"
  },
  {
    id: 5,
    title: "Riverside Fields",
    location: "Gujarat",
    area: "40 Acres",
    image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399",
    price: "₹35,000/acre/year"
  },
  {
    id: 6,
    title: "North Plains",
    location: "Haryana",
    area: "35 Acres",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    price: "₹48,000/acre/year"
  },
  {
    id: 7,
    title: "Eastern Plateau",
    location: "Bihar",
    area: "22 Acres",
    image: "https://images.unsplash.com/photo-1589328956162-4e2f54b36881",
    price: "₹40,000/acre/year"
  },
  {
    id: 8,
    title: "Central Fields",
    location: "Madhya Pradesh",
    area: "28 Acres",
    image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399",
    price: "₹37,000/acre/year"
  },
  {
    id: 9,
    title: "Coastal Plains",
    location: "Andhra Pradesh",
    area: "18 Acres",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    price: "₹44,000/acre/year"
  }
];

const LandLeasing = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-[60vh] bg-cover bg-center" 
           style={{backgroundImage: "url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2000')"}}>
        <div className="absolute inset-0 bg-black bg-opacity-50">
          <div className="h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Land for Growth
            </h1>
            <p className="text-xl text-white mb-8 max-w-2xl">
              Find the perfect agricultural land for lease. Cultivate success with our verified land listings across India.
            </p>
            <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-300 w-fit">
              Explore Listings
            </button>
          </div>
        </div>
      </div>

      {/* Land Listings Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">
          Land Rental Thumbnails
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {landListings.map((land) => (
            <div key={land.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={land.image} 
                  alt={land.title}
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {land.title}
                </h3>
                
                <div className="flex items-center text-gray-600 mb-2">
                  <FaMapMarkerAlt className="mr-2" />
                  <span>{land.location}</span>
                </div>
                
                <div className="flex items-center text-gray-600 mb-4">
                  <FaRulerCombined className="mr-2" />
                  <span>{land.area}</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-green-600 font-semibold">
                    {land.price}
                  </span>
                  <button className="bg-green-100 text-green-600 px-4 py-2 rounded-lg hover:bg-green-200 transition-colors duration-300">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Contact Us Today
          </h2>
          <p className="text-gray-600 mb-8">
            Ready to find your perfect agricultural land? Our experts are here to help.
          </p>
          <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-300">
            Get in Touch
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandLeasing;